import {Box, Icon, Stack, Text} from "@mbank-design/design-system/components";
import {MapMarkerColor} from "@mbank-design/design-system/icons";
import {SpeakerInvitationCreateLocation} from "../../../model/SpeakerInvitationCreateMessage";
import React from "react";

interface ConferenceLocationProps {
    conferenceLocation: SpeakerInvitationCreateLocation;
}

export default function ConferenceLocation({conferenceLocation} : ConferenceLocationProps) {
    const conferenceNameWithCity = `${conferenceLocation?.name}, ${conferenceLocation?.city}`;
    const conferenceAddress = `${conferenceLocation?.streetAndNumber}, ${conferenceLocation?.postalCode}`;
    
    return(
        <Stack direction="row" alignY="flex-start">
            <Icon iconComponent={MapMarkerColor} size={24}/>
            <Box>
                <Text as={"small"} color={"doveGrayUI"}>where?</Text>
                <Text>{conferenceNameWithCity}</Text>
                <Text as={"small"}>{conferenceAddress}</Text>
            </Box>

        </Stack>
    );
}